Vue.component('content-footer', {
    delimiters: ['[[', ']]'],
    template: `
        <div>
            <div class="row d-md-flex flex-wrap align-items-center" style='text-align:center'>

                <div class="lqd-column col-md-4 col-xs-6 mb-30">

                    <h3 class="widget-title">Main Navigation</h3>
                    <ul class="lqd-custom-menu reset-ul font-size-14 lh-2">
                        <li><a href="#how">How it works</a></li>
                        <li><a href="#features">Features</a></li>
                        <li><a href="#pricing">Pricing</a></li>
                        <li><br></li>
                    </ul>

                </div><!-- /.col-md-3 -->

                <div class="lqd-column col-md-4 col-xs-6 mb-30">

                        <h3 class="widget-title">Contact</h3>
                        <ul class="lqd-custom-menu reset-ul font-size-14 lh-2">
                            <li><a href="#contactUs" data-lity="#contactUs">Contact us</a></li>
                            <li><a href="#contentSpartacusLab" data-lity="#contentSpartacusLab">Spartacus Lab SARL</a></li>
                            <li><a href="#contactPartner" data-lity="#contactPartner">Become a partner</a></li>
                            <li><br></li>
                        </ul>

                </div><!-- /.col-md-3 -->

                <div class="lqd-column col-md-4 col-xs-6 mb-30">

                    <h3 class="widget-title">License</h3>
                    <ul class="lqd-custom-menu reset-ul font-size-14 lh-2">
                        <li><a href="/terms">Terms of service</a></li>
                        <li><br></li>
                        <li><br></li>
                    </ul>

                </div><!-- /.col-md-3 -->

            </div><!-- /.row -->
        </div>
    `,
    props: {
        idcomponent: {
            type: String,
            default: 'menu'
        },
    },
    data: function () {
        return {
            menuType: 1,
        }
    },
    mounted(){

    },
    methods: {
        test: function(){

        }
    },
});